import { SiteUrls } from '@tableau/shared-urls';
import _ from 'underscore';

import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import { FeatureFlags } from '../../ts/FeatureFlags';
import { QueryParameterHelper } from '../../ts/helpers/QueryParameterHelper';
import { FilterFieldNames } from '../../ts/ServerApi/types/IFilterClause';
import { UrlParamKeys } from '../UrlParamKeys';

// Return the query parameters that are in the hash (i.e. from Angular), as an object
export function getQueryParameters(): any {
  const search: any = WindowLocationService.getHashQueryObject();
  return search;
}

// Add the current query parameters that are in the hash to the given url
export function addQuery(url: string, omitOrderQueryParam: boolean = false, omitContentTypeQueryParam: boolean = false): string {
  let params = getQueryParameters();
  if (omitOrderQueryParam) {
    params = _.omit(params, UrlParamKeys.Order);
  }
  if (omitContentTypeQueryParam) {
    params = _.omit(params, FilterFieldNames.contentType);
  }
  return QueryParameterHelper.urlWithParams(url, params);
}

// TODO: This subclass should be removed.
// The remaining methods should either be moved to SiteUrls
// or to separate helpers. We should do that work when removing the mixedContentEnabled feature flag.

export class SpacesSiteUrls extends SiteUrls {

  constructor(config: { siteUrlName: string, queryString?: string }) {
    super({
      siteUrlName: config.siteUrlName,
      // Many existing call sites expect queryString to be filled in automatically
      queryString: config.queryString != null ? config.queryString : window.location.search,
    });
  }

  //
  // URLs go below here
  //

  public exploreSiteDataconnectionsUrl(): string {
    return this.datasourcesUrl() + '?' + FilterFieldNames.contentType + '=' + 'dataconnection';
  }

  public exploreDataConnectionUrl(dataConnectionId: string) {
    // This URL navigates to the data source by its Unified Datasource (connection) ID
      return this.datasourceDataConnectionUrl(dataConnectionId);
  }

  public userDataconnectionsUrl(username: string, domainName: string) {
    const url = this.userDatasourcesUrl(username, domainName);
    return url + '?' + FilterFieldNames.contentType + '=' + 'dataconnection';
  }

  public contentRootUrl(): string {
    return FeatureFlags.homePage ? this.homeUrl() : this.exploreUrl();
  }

  public contentRootPath(): string {
    return FeatureFlags.homePage ? this.homePath() : this.explorePath();
  }
}
